import { Badge } from "@/components/ui/badge";

type EventCategoryBadgeProps = {
  category: string;
};

export function EventCategoryBadge({ category }: EventCategoryBadgeProps) {
  return (
    <Badge variant="primary" className="self-start capitalize">
      {category.toLowerCase()}
    </Badge>
  );
}
